import {createSlice} from './createSlice';
import {onHolderConnectedChange} from '../../services/device/connectionService';
import deviceConnectionStatusTypes from '../../consts/device/deviceConnectionStatusTypes';

const getInitialState = () => {
    return {
        firmwareData: {},
        deviceSerialNumber: undefined,
        isIdentified: false,
        isDisconnectedWithNoReconnect: true,
        isHolderConnected: false,
    };
};

const slice = createSlice(getInitialState());

export const getState = slice.getState;
export const setState = slice.setState;

export const setMwDeviceInternalId = ({deviceSerialNumber, isIdentified}) => {
    setState({
        deviceSerialNumber,
        isIdentified,
    });
};

export const setIsHolderConnected = (isConnected) => {
    const curIsHolderConnected = getState().isHolderConnected;

    if (curIsHolderConnected === isConnected) return;

    setState({isHolderConnected: isConnected});
    onHolderConnectedChange(
        isConnected ? deviceConnectionStatusTypes.CONNECTED : deviceConnectionStatusTypes.DISCONNECTED
    );
};

export const resetMwState = () => {
    setState(getInitialState());
};

// export default (state = initialState, action: IMwAction): IMwState => {
//     switch (action.type) {
//         case ActionTypes.CLEAR_MW_DEVICE: {
//             return initialState;
//         }
//         case ActionTypes.SET_MW_DEVICE_FIRMWARE_DATA: {
//             const {firmwareData} = action.payload as IFirmwareData;

//             return {...state, firmwareData: {...state.firmwareData, ...firmwareData}};
//         }
//         case ActionTypes.SET_MW_DEVICE_IS_DISCONNECTED_WITH_NO_RECONNECT: {
//             const {isDisconnectedWithNoReconnect} = action.payload as IIsDisconnectedWithNoReconnect;

//             return {...state, isDisconnectedWithNoReconnect};
//         }
//         case ActionTypes.SET_MW_DEVICE_INTERNAL_ID: {
//             const {deviceSerialNumber, isIdentified} = action.payload as IMwInternalId;

//             return {...state, deviceSerialNumber, isIdentified};
//         }
//         default:
//             return state;
//     }
// };

// export const setMwDeviceFirmwareData = (firmwareData: TFirmwareData): IMwAction => ({
//     type: ActionTypes.SET_MW_DEVICE_FIRMWARE_DATA,
//     payload: {firmwareData},
// });

// export const setMwDeviceIsDisconnectedWithNoReconnect = (isDisconnectedWithNoReconnect: boolean): IMwAction => ({
//     type: ActionTypes.SET_MW_DEVICE_IS_DISCONNECTED_WITH_NO_RECONNECT,
//     payload: {isDisconnectedWithNoReconnect},
// });

// export const clearMwDeviceInternalId = (): IMwAction => ({
//     type: ActionTypes.SET_MW_DEVICE_INTERNAL_ID,
//     payload: {deviceSerialNumber: undefined, isIdentified: false},
// });
